var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5889 14.4121C32.1404 13.8605 33.0354 13.8605 33.5869 14.4121C34.1381 14.9636 34.1381 15.8577 33.5869 16.4092L25.9971 23.998L33.5732 31.5742C34.1245 32.1258 34.1247 33.0199 33.5732 33.5713C33.0218 34.1227 32.1277 34.1226 31.5762 33.5713L24.001 25.9961L16.4111 33.5869C15.8596 34.1385 14.9656 34.1385 14.4141 33.5869C13.8626 33.0353 13.8625 32.1414 14.4141 31.5898L22.0029 23.998L14.4141 16.4092C13.8625 15.8576 13.8625 14.9636 14.4141 14.4121C14.9656 13.8606 15.8596 13.8606 16.4111 14.4121L24 22.001L31.5889 14.4121Z",
    fill: "#D12F23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRed);
export default __webpack_public_path__ + "static/media/CROSS_RED.ad10c3e384b0e2d0ec6aafe58d47b561.svg";
export { ForwardRef as ReactComponent };